import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/disk/import-doc.svg';
const ImportDocSvg = () => React.createElement(IconSvg, null);
export default ImportDocSvg;
